import moment from 'moment';

const WaitingListAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'companies.title': i?.company?.name,
    created_at: moment(i?.created_at).format('DD/MM/YYYY HH:mm'),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default WaitingListAdapter;
